import { useEffect } from 'react';
import { auth } from './firebaseConfig';
import { signOut } from 'firebase/auth';

const INACTIVITY_LIMIT = 5 * 60 * 1000; // 5 minutes

let inactivityTimer;

function resetTimer() {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    signOut(auth);
    console.log('User auto-logged out due to inactivity');
  }, INACTIVITY_LIMIT);
}

const useInactivityLogout = () => {
  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // Start timer on mount

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      clearTimeout(inactivityTimer);
    };
  }, []);
};

export default useInactivityLogout;
